<script>
  export let message = '';
  export let type = 'error'; // error, warning, info, success
  export let dismissible = false;
  export let onDismiss = () => {};
</script>

{#if message}
  <div class="error-message error-message-{type}">
    <div class="error-content">
      <div class="error-text">{message}</div>
      {#if dismissible}
        <button class="error-dismiss" on:click={onDismiss} aria-label="닫기">×</button>
      {/if}
    </div>
  </div>
{/if}

<style>
  .error-message {
    padding: 12px 16px;
    border-radius: 6px;
    margin-bottom: 16px;
    border: 1px solid;
    font-size: 0.95rem;
    line-height: 1.4;
  }

  .error-content {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }

  .error-text {
    flex: 1;
  }

  .error-dismiss {
    background: none;
    border: none;
    font-size: 1.2rem;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    opacity: 0.7;
    transition: opacity 0.2s ease;
    min-width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .error-dismiss:hover {
    opacity: 1;
  }

  /* Error type */
  .error-message-error {
    background-color: #fff5f5;
    color: #e03131;
    border-color: #ffc9c9;
  }

  .error-message-error .error-dismiss {
    color: #e03131;
  }

  /* Warning type */
  .error-message-warning {
    background-color: #fff9db;
    color: #f59f00;
    border-color: #ffec99;
  }

  .error-message-warning .error-dismiss {
    color: #f59f00;
  }

  /* Info type */
  .error-message-info {
    background-color: #e7f5ff;
    color: #3273dc;
    border-color: #a5d8ff;
  }

  .error-message-info .error-dismiss {
    color: #3273dc;
  }

  /* Success type */
  .error-message-success {
    background-color: #d3f9d8;
    color: #2b8a3e;
    border-color: #8ce99a;
  }

  .error-message-success .error-dismiss {
    color: #2b8a3e;
  }
</style> 